var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-badge',{attrs:{"content":_vm.unReadCount,"value":_vm.unReadCount,"color":"success","overlap":""}},[(_vm.loading)?_c('v-progress-circular',{attrs:{"indeterminate":""}}):_c('v-icon',[_vm._v("mdi-forum")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }